import {Injectable, OnDestroy} from '@angular/core';
import {OwlDateTimeIntl, DateTimeAdapter} from "ng-pick-datetime-ex";
import {TranslateService} from '../../../../services/translate/translate.service';
import {GlobalModel} from '../../../../services/state/global.model';
import {Subscription} from 'rxjs';

@Injectable() export class OwlDateTimeLocalization extends OwlDateTimeIntl implements OnDestroy {

    private languageSubscription: Subscription;

    constructor(
        private translateService: TranslateService,
        private dateTimeAdapter: DateTimeAdapter<any>,
        private model: GlobalModel
    ) {
        super();
        this.updateLocale();
        
        // Subscribe to language changes to update the date picker locale
        this.languageSubscription = this.model.changeLanguage.subscribe(() => {
            this.updateLocale();
            this.updateLabels();
            this.changes.next();
        });
    }

    private updateLocale(): void {
        // Use the full locale (e.g., 'nl-NL') instead of just language code (e.g., 'nl')
        this.dateTimeAdapter.setLocale(TranslateService.LOCALE);
    }

    private updateLabels(): void {
        this.cancelBtnLabel = this.translateService.translate('datetimepicker.cancelBtnLabel');
        this.setBtnLabel = this.translateService.translate('datetimepicker.setBtnLabel');
        this.rangeFromLabel = this.translateService.translate('datetimepicker.rangeFromLabel');
        this.rangeToLabel = this.translateService.translate('datetimepicker.rangeToLabel');
    }

    /** A label for the cancel button */
    cancelBtnLabel = this.translateService.translate('datetimepicker.cancelBtnLabel');

    /** A label for the set button */
    setBtnLabel = this.translateService.translate('datetimepicker.setBtnLabel');

    /** A label for the range 'from' in picker info */
    rangeFromLabel = this.translateService.translate('datetimepicker.rangeFromLabel');

    /** A label for the range 'to' in picker info */
    rangeToLabel = this.translateService.translate('datetimepicker.rangeToLabel');

    ngOnDestroy(): void {
        if (this.languageSubscription) {
            this.languageSubscription.unsubscribe();
        }
    }
}

